var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('status-template',{attrs:{"feature":"gallery","prestigeGain":_vm.prestigeGain}}),_c('global-level-status')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }